// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"0db6b038","145":"eada4707","387":"2ea1d8e9","848":"a7361702","875":"02f14557"}[chunkId] + ".chunk.css";
};